import { dynamicObject360Constants } from '../constants/globalConstant';

export const getDynamicObject360Label = (entityCustomisation, leadTypesEnabled) => {
  const defaultTitle = dynamicObject360Constants(entityCustomisation?.SingularName)?.DEFAULT_TITLE;
  const dynamicTitle = dynamicObject360Constants(entityCustomisation?.SingularName)?.DYNAMIC_TITLE;
  return leadTypesEnabled ? defaultTitle : dynamicTitle;
};
